import { z } from 'zod'

import {
	PRODUCT_CATEGORY_OPTIONS,
	PRODUCT_STATUS_OPTIONS,
	PROFESSIONAL_USE_OPTIONS,
	PRODUCT_DATA_SOURCE_OPTIONS,
} from '#app/routes/mocra+/_form+/intake-options.ts'

export type ProductDataSourceValue =
	(typeof PRODUCT_DATA_SOURCE_OPTIONS)[number]['value']

export const ProductEntrySchema = z
	.object({
		name: z
			.string({
				required_error: 'Enter the product name.',
			})
			.min(1, 'Enter the product name.'),
		sku: z.string().optional(),
		category: z.enum(
			PRODUCT_CATEGORY_OPTIONS.map((option) => option.value) as [
				(typeof PRODUCT_CATEGORY_OPTIONS)[number]['value'],
				...string[],
			],
		),
		categoryOther: z.string().optional(),
		professionalUse: z.enum(
			PROFESSIONAL_USE_OPTIONS.map((option) => option.value) as [
				(typeof PROFESSIONAL_USE_OPTIONS)[number]['value'],
				...string[],
			],
		),
		status: z.enum(
			PRODUCT_STATUS_OPTIONS.map((option) => option.value) as [
				(typeof PRODUCT_STATUS_OPTIONS)[number]['value'],
				...string[],
			],
		),
	})
	.superRefine((data, ctx) => {
		if (data.category === 'other' && !data.categoryOther?.trim()) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: 'Enter the product category.',
				path: ['categoryOther'],
			})
		}
	})

export type ProductEntry = z.infer<typeof ProductEntrySchema>

export const ProductDataSourceEnum = z.enum(
	PRODUCT_DATA_SOURCE_OPTIONS.map((option) => option.value) as [
		ProductDataSourceValue,
		...ProductDataSourceValue[],
	],
)
